export default __webpack_public_path__ + "static/media/incontext-slides.42f74ea8.pdf";